import { render } from "./Temples.vue?vue&type=template&id=098443f8&scoped=true"
import script from "./Temples.vue?vue&type=script&lang=js"
export * from "./Temples.vue?vue&type=script&lang=js"

import "./Temples.vue?vue&type=style&index=0&id=098443f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098443f8"]])

export default __exports__